import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import './App.css';

//REDUCER FUNCTION
const reducer = (state = 9,action) => {
  switch (action.type) {
    case 'Cancel':
      return "Cancelled Successfully";
    case 'Save':
      return "Saved Successfully";
    default:
      return state;
  }
};

//STORE
var store = createStore(reducer);

//APP
const App = ({ value }) => {
  return (
      <div className="App">
      <div className="topbar-grey"><div className="topbar"></div></div>
      <header className="App-header">
      <div className = "form">
        <div className="taskmenu">
          <div className = "taskname">TASKS 0
          </div>
          <div className = "addstyle">+
          </div>
        </div>
        <div>
            <label for="fname" className="taskdes">Task Description</label><br></br>
            <input type="text" id="fname" name="fname" placeholder="Follow Up" className="InputBox"></input><br></br>
            <label for="fname" className="taskdesDate">Date</label>
            <label for="fname" className="taskdesTime">Time</label><br></br>
            <input type="date" id="fname" name="fname" className="InputBoxDate"></input>
            <select name="cars" id="cars" className="InputBoxtime">
              <option value="volvo">12.00 am</option>
              <option value="saab">12.30 am</option>
              <option value="mercedes">1.00 am</option>
              <option value="audi">1.30 am</option>
              <option value="volvo">2.00 am</option>
              <option value="saab">2.30 am</option>
              <option value="mercedes">3.00 am</option>
              <option value="audi">3.30 am</option>
              <option value="volvo">4.00 am</option>
              <option value="saab">4.30 am</option>
              <option value="mercedes">5.00 am</option>
              <option value="audi">5.30 am</option>
              <option value="volvo">6.00 am</option>
              <option value="saab">6.30 am</option>
              <option value="mercedes">7.00 am</option>
              <option value="audi">7.30 am</option>
              <option value="volvo">8.00 am</option>
              <option value="saab">8.30 am</option>
              <option value="mercedes">9.00 am</option>
              <option value="audi">9.30 am</option>
              <option value="volvo">10.00 am</option>
              <option value="saab">10.30 am</option>
              <option value="mercedes">11.00 am</option>
              <option value="audi">11.30 am</option>
              <option value="volvo">12.00 pm</option>
              <option value="saab">12.30 pm</option>
              <option value="mercedes">1.00 pm</option>
              <option value="audi">1.30 pm</option>
              <option value="volvo">2.00 pm</option>
              <option value="saab">2.30 pm</option>
              <option value="mercedes">3.00 pm</option>
              <option value="audi">3.30 pm</option>
              <option value="volvo">4.00 pm</option>
              <option value="saab">4.30 pm</option>
              <option value="mercedes">5.00 pm</option>
              <option value="audi">5.30 pm</option>
              <option value="volvo">6.00 pm</option>
              <option value="saab">6.30 pm</option>
              <option value="mercedes">7.00 pm</option>
              <option value="audi">7.30 pm</option>
              <option value="volvo">8.00 pm</option>
              <option value="saab">8.30 pm</option>
              <option value="mercedes">9.00 pm</option>
              <option value="audi">9.30 pm</option>
              <option value="volvo">10.00 pm</option>
              <option value="saab">10.30 pm</option>
              <option value="mercedes">11.00 pm</option>
              <option value="audi">11.30 pm</option>
            </select><br></br>
            <label for="fname" className="taskdesDate">Assign User</label><br></br>
            <input type="text" id="fname" name="fname" placeholder="Nisangan" className="InputBox"></input>
            <div className="button-footer">
            <button className="Cancel" onClick={() => { store.dispatch({ type: 'Cancel' }) }}>Cancel</button>
            <button className="submit" onClick={() => { store.dispatch({ type: 'Save' }) }}>Save</button>
            </div>
        </div>
      </div>
      </header> 
    </div>
  )
};

const render = () => ReactDOM.render(<App value={store.getState()} />, document.getElementById('root'));
render();

store.subscribe(render); //SUBSCRIBE